
import { AuditFaultTypeModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { auditFaultTypesStore } from '@/libs/audit-fault-types/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({})
export default class WorkplaceSelect extends Vue {
    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: null }) auditId!: string | string[] | null;
    @Prop({ default: false }) truncateSelection!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): AuditFaultTypeModel[] {
        let items = [...(auditFaultTypesStore.useGetter(CrudGetter.Data) as AuditFaultTypeModel[])];
        if (this.auditId) {
            if (Array.isArray(this.auditId)) {
                items = items.filter((x) => this.auditId?.contains(x.auditId!) == true);
            } else if (this.auditId.length > 0) {
                items = items.filter((x) => x.auditId === this.auditId);
            }
        }
        return items.sort((a: AuditFaultTypeModel, b: AuditFaultTypeModel) => {
            if (a.name! < b.name!) {
                return -1;
            }
            if (a.name! > b.name!) {
                return 1;
            }
            return 0;
        });
    }

    mounted() {
        auditFaultTypesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload());
    }

    getName(e: AuditFaultTypeModel) {
        if (e.priority) {
            return `${e.name} (${this.$i18n.t('planItems.priority')}: ${e.priority})`;
        }
        return e.name;
    }
}
